import Alpine from 'alpinejs'

const initAlpine = () => {
    window.Alpine = Alpine
    Alpine.prefix('data-x-')
    Alpine.start()

}

export default initAlpine
